import { useQuery } from '@tanstack/react-query'
import { LiquidProduct } from '@/features/product/types'

interface UseRecommendationsOptions {
  id?: number
  filterProducts: number[]
  minRecommendations?: number
  maxRecommendations?: number
}

export const useRecommendations = ({
  id,
  filterProducts = [],
  maxRecommendations = 12,
  minRecommendations = 6,
}: UseRecommendationsOptions) => {
  const fetchRecommendations = async (): Promise<LiquidProduct[]> => {
    try {
      const res = await fetch(
        new URL(
          `/recommendations/products?product_id=${id}&limit=${maxRecommendations}&section_id=recommendations`,
          window.location.origin
        ).href
      )
      const htmlString = await res.text()
      const jsonString = htmlString!.match(
        /<script type="application\/json">([\s\S]*?)<\/script>/
      )![1]

      return JSON.parse(jsonString)
    } catch (err) {
      return []
    }
  }

  const filterList = (recommendations: LiquidProduct[]) => {
    const filteredList = recommendations.filter(
      ({ id }) => !filterProducts.includes(id)
    )

    const remainingLength = minRecommendations - filteredList.length
    if (remainingLength > 0) {
      const remainingItems = recommendations
        .filter(({ id }) => filterProducts.includes(id))
        .slice(0, remainingLength)
      return [...filteredList, ...remainingItems]
    }

    return filteredList
  }

  return useQuery({
    queryKey: ['product-recommendations', id],
    queryFn: async () => filterList(await fetchRecommendations()),
    enabled: Boolean(id),
  })
}
